export default {
  title: {
    id: 'funnel_page_title',
    defaultMessage: 'Your green cart | Back Market',
  },
  description: {
    id: 'funnel_page_description',
    defaultMessage:
      'Fill your cart with refurbished products on Back Market. Save cash by spending less on the good stuff, backed by warranties.',
  },
}
